import { tickerItems } from "@/mocks/home";

export default function TopTicker() {
  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="flex w-full items-center gap-3 px-4 py-2.5 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
          <span className="h-1.5 w-1.5 rounded-full bg-background-50 animate-pulse-dot"></span>
          入口同步中
        </span>
        <div className="relative hidden flex-1 overflow-hidden sm:block">
          <div className="flex w-max animate-marquee gap-10">
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <span key={index} className="whitespace-nowrap text-xs text-background-200 md:text-sm">
                {item}
              </span>
            ))}
          </div>
        </div>
        <span className="flex-1 truncate text-xs text-background-200 sm:hidden">{tickerItems[0]}</span>
        <span className="hidden shrink-0 items-center gap-1.5 font-label text-xs text-accent-400 md:flex">
          <i className="ri-history-line"></i>
          更新于 2026-09-10 14:20
        </span>
      </div>
    </div>
  );
}